import PropTypes from 'prop-types';
import React from 'react';
import { withRouter } from 'react-router';

import Auth from '../../utils/Auth';
import ElectronicJournal from '../ElectronicJournal';

class Home extends React.Component {
  signOut = () => {
    Auth.logout();
    // eslint-disable-next-line fp/no-mutating-methods
    this.props.history.push('/login');
  };

  render = () => (
    <article>
      <ElectronicJournal changeLoading={this.props.changeLoading} />
    </article>
  );
}

Home.propTypes = {
  changeLoading: PropTypes.func.isRequired,
  history: PropTypes.shape().isRequired,
};

export default (withRouter(Home));
